import React from 'react'

import { zebraStripes } from '@uiw/codemirror-extensions-zebra-stripes'

import { Editor } from '../Editor'

const getIncorrectLineNumber = (resultsByLines: boolean[] | null) => {
  if (!resultsByLines) return []

  const result: number[] = []

  resultsByLines?.forEach((item, index) => {
    if (!item) {
      result.push(index + 1)
    }
  })

  return result
}

type PropsType = {
  value: string
  language: string
  onChange: (lines: string[]) => void
  onCreateEditor: (lines: string[]) => void
  resultsByLines: boolean[] | null
  scrollTop: number
}

export const DisplayingEditor = ({
  value,
  language,
  resultsByLines,
  onChange,
  onCreateEditor,
  scrollTop,
}: PropsType) => {
  const incorrectLineNumbers = getIncorrectLineNumber(resultsByLines)

  const onCreateEditorHandler = (view: any) => {
    const lines = view.state.doc.text

    onCreateEditor(lines)
  }

  const onChangeHandler = (value: string, view: any) => {
    const lines = view.state.doc.text

    onChange(lines)
  }

  return (
    <Editor
      scrollTop={scrollTop}
      value={value}
      language={language}
      editable={false}
      onChange={onChangeHandler}
      onCreateEditor={onCreateEditorHandler}
      extraExtensions={[
        zebraStripes({
          lineNumber: incorrectLineNumbers.length !== 0 ? incorrectLineNumbers : [0],
          lightColor: 'rgba(255, 39, 94, 0.15)',
        }),
      ]}
    />
  )
}
